import { useEffect } from "react";

interface DocumentMeta {
  title: string;
  description?: string;
  keywords?: string;
}

export function useDocumentMeta({ title, description, keywords }: DocumentMeta) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const upsertMeta = (name: string, content?: string) => {
      if (!content) return;
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    upsertMeta("description", description);
    upsertMeta("keywords", keywords);

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, keywords]);
}